import { render, staticRenderFns } from "./addPublicvenue-dialog.vue?vue&type=template&id=4d4a0ebc&scoped=true"
import script from "./addPublicvenue-dialog.vue?vue&type=script&lang=js"
export * from "./addPublicvenue-dialog.vue?vue&type=script&lang=js"
import style0 from "./addPublicvenue-dialog.vue?vue&type=style&index=0&id=4d4a0ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4a0ebc",
  null
  
)

export default component.exports